export enum AdBreakType {
    PRE = 'PRE',
    MID = 'MID',
    POST = 'POST'
}
